// extracted by mini-css-extract-plugin
module.exports = {"button":"ErrorModalFooter_button__CLoUn","buttonText":"ErrorModalFooter_buttonText__0AIX2","secondary":"ErrorModalFooter_secondary__udupJ"};